import { useEffect, useState } from "react";
import { PageHero, SectionHeading, CTABand } from "../components/shared";
import { Reveal } from "../components/Reveal";
import { PROJECT_FILTERS, SAMPLE_PROJECTS, IMAGES } from "../data/content";
import { api } from "../lib/api";

const Projects = () => {
  const [projects, setProjects] = useState(SAMPLE_PROJECTS);
  const [filter, setFilter] = useState("All");
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/projects").then(({ data }) => {
      if (Array.isArray(data) && data.length) setProjects([...data, ...SAMPLE_PROJECTS]);
    }).catch(() => {});
  }, []);

  const filtered = filter === "All" ? projects : projects.filter((p) => p.category === filter);

  return (
    <>
      <PageHero overline="Projects" title="Project & Case-Study Experience" subtitle="Representative engagements across rollout, maintenance, fibre, electrical, civil and manpower. Client names withheld for commercial confidentiality." image={IMAGES.tower2} />
      <section className="py-24 bg-white">
        <div className="max-w-[1360px] mx-auto px-5 md:px-8">
          <SectionHeading overline="Case Studies" title="Filter by Capability" />
          <div className="mt-8 flex flex-wrap gap-2" data-testid="project-filters">
            {["All", ...PROJECT_FILTERS].map((f) => (
              <button key={f} onClick={() => setFilter(f)} data-testid={`filter-${f.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${filter === f ? "bg-[#0B1F3A] text-white border-[#0B1F3A]" : "bg-white text-[#252B33] border-[#E2E8F0] hover:border-[#1EA7E1]"}`}>{f}</button>
            ))}
          </div>
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filtered.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.06}>
                <button onClick={() => setActive(p)} data-testid={`project-${p.id}`} className="text-left h-full w-full bg-white border border-[#E2E8F0] rounded-lg overflow-hidden hover-lift hover:shadow-xl">
                  <div className="relative h-48 overflow-hidden"><img src={p.image || IMAGES.tower2} alt={p.title} loading="lazy" className="w-full h-full object-cover" /><span className="absolute top-3 left-3 bg-[#0B1F3A]/80 text-white text-xs px-2.5 py-1 rounded">{p.category}</span></div>
                  <div className="p-6">
                    <h3 className="font-head font-semibold text-lg text-[#0B1F3A]">{p.title}</h3>
                    <p className="mt-2 text-sm text-[#64748B]">{p.client_type} · {p.location}</p>
                    <p className="mt-3 text-sm text-[#64748B] line-clamp-2">{p.requirement}</p>
                    <span className="mt-4 inline-block text-sm font-semibold text-[#1261A0]">Read case study →</span>
                  </div>
                </button>
              </Reveal>
            ))}
          </div>
          {!filtered.length && <p className="mt-10 text-[#64748B]">No projects in this category yet.</p>}
        </div>
      </section>

      {active && (
        <div className="fixed inset-0 z-[70] grid place-items-center p-4" data-testid="project-modal">
          <div className="absolute inset-0 bg-[#0B1F3A]/70 backdrop-blur-sm" onClick={() => setActive(null)} />
          <div className="relative bg-white rounded-lg max-w-2xl w-full max-h-[86vh] overflow-y-auto">
            <img src={active.image || IMAGES.tower2} alt={active.title} className="w-full h-52 object-cover rounded-t-lg" />
            <div className="p-7">
              <span className="bg-[#0B1F3A] text-white text-xs px-2.5 py-1 rounded">{active.category}</span>
              <h3 className="mt-4 font-head font-bold text-2xl text-[#0B1F3A]">{active.title}</h3>
              <p className="mt-1 text-sm text-[#64748B]">{active.client_type} · {active.location} · {active.period}</p>
              <dl className="mt-5 space-y-4 text-sm">
                {[["Requirement", active.requirement], ["Challenge", active.challenge], ["Scope Delivered", active.scope], ["Delivery Approach", active.approach], ["Result", active.result]].filter(([, v]) => v).map(([k, v]) => (
                  <div key={k}><dt className="font-semibold text-[#F28C28] uppercase tracking-wide text-xs">{k}</dt><dd className="mt-1 text-[#252B33]">{v}</dd></div>
                ))}
              </dl>
              <p className="mt-5 text-sm italic text-[#64748B]">{active.testimonial}</p>
              <button onClick={() => setActive(null)} className="mt-6 bg-[#0B1F3A] text-white px-5 py-2.5 rounded-md" data-testid="modal-close">Close</button>
            </div>
          </div>
        </div>
      )}
      <CTABand />
    </>
  );
};

export default Projects;
